<template>
  <div>
    <div>
      <p class="icon-jujue closeBtn" @click="routerBack"></p>
    </div>
    <div class="content_box">
      <el-row style="margin:5px 0">
        <el-button size="mini" class="btn" type="primary" @click="onSubmit" v-acl="RMC_PROD_FARM_SUBMIT" v-if="ms_roles.indexOf('QSPI_RMC_PRODUCE_SPONS_SUPP') !== -1">提交</el-button>
      </el-row>
      <el-form :model="detailForm" ref="detailForm" :rules="rules" label-width="120px">
        <div class="within_box">
          <div class="title_box">
            <p class="line"></p>
            <p class="title">农场清单</p>
          </div>
          <div class="form_box">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="Category3" prop="category3Name">
                  <el-input v-model="detailForm.category3Name" disabled style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="Sponsor" prop="sponsorName">
                  <el-input v-model="detailForm.sponsorName" disabled style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="Farm Group" prop="farmGroup" :rules="rules.farmGroup" class="is-required">
                  <el-select v-model="detailForm.farmGroup" clearable placeholder="请选择" style="width:100%">
                    <el-option :key="index" v-for="(item, index) in farmGroupOptions" :label="item" :value="item"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="农场" prop="farmName" class="is-required">
                  <el-input v-model="detailForm.farmName" disabled style="width:100%"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="审核类型" prop="party">
                  <el-select v-model="detailForm.party" @change="partyChange" placeholder="请选择" style="width:100%">
                    <el-option :key="index" v-for="(item, index) in partyOptions" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="2方验证审核结果" prop="partyAuditResult2" v-if="isShow">
                  <el-input v-model="detailForm.partyAuditResult2" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="2方验证审核时间" prop="partyAuditDate2" v-if="isShow">
                  <el-date-picker v-model="detailForm.partyAuditDate2" type="date" value-format="yyyy-MM-dd" placeholder="请选择" style="width:100%"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="3方验证审核时间" prop="partyAuditDate3" v-if="!isShow">
                  <el-date-picker v-model="detailForm.partyAuditDate3" type="date" value-format="yyyy-MM-dd" placeholder="请选择" style="width:100%"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="MGG审核结果" prop="mggAuditResult" v-if="!isShow">
                  <el-input v-model="detailForm.mggAuditResult" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="GGAP审核结果" prop="ggapAuditResult" v-if="!isShow">
                  <el-select v-model="detailForm.ggapAuditResult" clearable placeholder="请选择" style="width:100%">
                    <el-option :key="index" v-for="(item, index) in ggapAuditResultOptions" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                  <!-- <el-input v-model="detailForm.ggapAuditResult" clearable style="width:100%"></el-input> -->
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20" v-if="!isShow">
              <el-col :span="6">
                <el-form-item label="GNN" prop="gnn">
                  <el-input v-model="detailForm.gnn" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="within_box">
          <div class="title_box">
            <p class="line"></p>
            <p class="title">验证审核报告</p>
          </div>
          <div class="form_box">
            <el-row style="margin-bottom:5px">
              <div v-if="ms_roles.indexOf('QSPI_RMC_PRODUCE_SPONS_SUPP') !== -1" v-acl="RMC_PROD_FARM_UPLOAD">
                <el-button size="small" type="primary" v-if="detailForm.party === 20" @click="openFile1">上传</el-button>
                <el-button size="small" type="primary" v-if="detailForm.party === 30" @click="openFile2">上传</el-button>
              </div>
            </el-row>
            <el-table ref="plxTable" :data="tableData" max-height="500" border highlight-current-row>
              <el-table-column align="center" label="操作" width="80">
                <template slot-scope="scope">
                  <el-button type="text" @click="onDel(scope.row.tmDocumentId,scope.$index,tableData,scope.row)" v-if="ms_userId === scope.row.createBy">删除</el-button>
                </template>
              </el-table-column>
              <el-table-column align="center" label="文件类型" prop="reportType" show-overflow-tooltip></el-table-column>
              <el-table-column align="center" label="文件名称" prop="documentName" show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-button type="text" @click="onDownload(scope.row, scope.$index)">{{ scope.row.documentName }}</el-button>
                </template>
              </el-table-column>
              <el-table-column align="center" label="文件描述" show-overflow-tooltip prop="docComments"></el-table-column>
              <el-table-column align="center" label="上传人" prop="userName" show-overflow-tooltip></el-table-column>
              <el-table-column align="center" label="上传时间" prop="createDate" show-overflow-tooltip></el-table-column>
            </el-table>
          </div>
        </div>
      </el-form>
    </div>
    <el-dialog title="附件上传" :visible.sync="dialogVisible1" width="30%" :before-close="handleClose1">
      <uploadFile1 v-if="dialogVisible1" @close="handleClose1" :seq="seq" :bizId="bizId" :recType="recType"></uploadFile1>
    </el-dialog>
    <el-dialog title="附件上传" :visible.sync="dialogVisible2" width="30%" :before-close="handleClose2">
      <uploadFile2 v-if="dialogVisible2" @close="handleClose2" :seq="seq" :bizId="bizId" :recType="recType"></uploadFile2>
    </el-dialog>
  </div>
</template>

<script>
import IcSelect from "@/components/common/icSelect";
import { fileService } from "@/api/common/file-utils";
import rmcProdFarmApi from "@/api/rmcProduce/farm";
import commonConstants from "@/constants/commonConstants";
import uploadFile1 from "../../Protein/rmcFarmList/uploadDialog/index.vue";
import uploadFile2 from "./uploadDialog/index.vue";
export default {
  name: "rmcProtFarmDetail",
  components: {
    IcSelect,
    uploadFile1,
    uploadFile2,
  },
  data() {
    var validateMggAuditResult = (rule, value, callback) => {
      console.log("🚀 ~ file: auditDetail.vue ~ line 148 ~ validateMggAuditResult ~ this.crop", this.crop);
      var crops = this.crop.split(",");
      var flag = this.cropOptions.filter((ele) => {
        return crops.includes(ele.code);
      }).some((el) => {
        return el.restrictFieldValue1 !== "1";
      });
      console.log("🚀 ~ file: auditDetail.vue ~ line 151 ~ flag ~ flag", flag)
      if (flag && !value) {
        callback(new Error("请输入MGG审核结果"));
      } else {
        callback();
      }
    };
    return {
      ms_roles: null,
      ms_userId: null,
      supplierObj: null,
      isShow: true,
      dialogVisible1: false,
      dialogVisible2: false,
      fileData: null,
      header: {
        "x-access-token": localStorage.getItem("token"),
      },
      uploadForm: {
        partyType: "",
        fileName: "",
        docComments: "",
      },
      uploadFormRules: {
        docComments: [
          { required: true, message: "请输入文件描述", trigger: "blur" },
        ],
      },
      rules: {
        farmGroup: [
          { required: true, message: "请选择Farm Group", trigger: "change" },
        ],
        party: [
          { required: true, message: "请选择审核类型", trigger: "change" },
        ],
        partyAuditDate2: [
          { required: true, message: "请选择2方审核时间", trigger: "change" },
        ],
        partyAuditResult2: [
          { required: true, message: "请输入2方审核结果", trigger: "blur" },
          {
            min: 1,
            max: 100,
            message:
              "字段“2方审核结果”已超出数据库长度要求（长度：100），请删减.",
            trigger: "blur",
          },
        ],
        partyAuditDate3: [
          { required: true, message: "请选择3方审核时间", trigger: "change" },
        ],
        mggAuditResult: [
          { validator: validateMggAuditResult, trigger: "blur" },
          {
            pattern: /^[+-]?\d+(\.\d+)?$/,
            message: "请输入数字",
            trigger: "blur",
          },
          {
            min: 1,
            max: 100,
            message:
              "字段“MGG审核结果”已超出数据库长度要求（长度：100），请删减.",
            trigger: "blur",
          },
        ],
        ggapAuditResult: [
          { required: true, message: "请输入GGAP审核结果", trigger: "blur" },
          {
            min: 1,
            max: 100,
            message:
              "字段“GGAP审核结果”已超出数据库长度要求（长度：100），请删减.",
            trigger: "blur",
          },
        ],
        gnn: [
          { required: true, message: "请输入GNN", trigger: "blur" },
          {
            pattern: /^[+-]?\d+(\.\d+)?$/,
            message: "请输入数字",
            trigger: "blur",
          },
          {
            min: 1,
            max: 100,
            message: "字段“GNN”已超出数据库长度要求（长度：100），请删减.",
            trigger: "blur",
          },
        ],
      },
      ggapAuditResultOptions: [
        {
          label: "Pass",
          value: "Pass",
        },
        {
          label: "Fail",
          value: "Fail",
        },
      ],
      detailForm: {
        category3Name: "",
        sponsorName: "",
        farmGroup: null,
        farmName: "",
        party: 20,
        partyAuditDate2: null,
        partyAuditResult2: null,
        partyAuditDate3: null,
        mggAuditResult: null,
        ggapAuditResult: null,
        gnn: null,
      },
      tableData: [],
      fileList: [],
      partyOptions: [
        {
          label: "2方验证审核报告",
          value: 20,
        },
        {
          label: "3方验证审核报告",
          value: 30,
        },
      ],
      ms_Permission: [],
      farmGroupOptions: [],
      cropOptions: [],
      ids: [],
      seq: "",
      bizId: "",
      recType: "",
      crop: "",
    };
  },
  watch: {},
  computed: {
    uploadUrl() {
      return (
        process.env.VUE_APP_SERVER_BASE_URL +
        `/file/RMC_PRODUCE_FARM_AUDIT_REPORT/${this.uploadForm.reportType}/${this.$route.query.rmcProduceFarmId}`
      );
    },
  },
  created() {
    this.ms_userId = JSON.parse(localStorage.getItem("ms_userId"));
    this.ms_roles = JSON.parse(localStorage.getItem("ms_roles"));
    this.supplierObj = JSON.parse(localStorage.getItem("supplierObj"));
    this.getCrop();
    if (this.$route.query.rmcProduceFarmId) {
      this.ids.push(this.$route.query.rmcProduceFarmId);
      this.getDetailInfo();
    }
    if (this.supplierObj) {
      this.getFarmGroupList(this.supplierObj.supplierCode);
    }
    if (this.detailForm.party) {
      this.getPartyAuditReportList(
        this.detailForm.party,
        this.$route.query.rmcProduceFarmId
      );
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs["detailForm"].clearValidate();
    });
  },
  methods: {
    getDetailInfo() {
      rmcProdFarmApi
        .getFarmDetail(this.$route.query.rmcProduceFarmId)
        .then((res) => {
          console.log("获取农场明细111", res);
          this.$set(this.detailForm, "category3Name", res.data.category3Name);
          this.$set(this.detailForm, "sponsorName", res.data.sponsorName);
          this.$set(this.detailForm, "farmGroup", res.data.farmGroup);
          this.$set(this.detailForm, "farmName", res.data.farmName);
          this.$set(
            this.detailForm,
            "partyAuditDate2",
            res.data.secondPartyAuditDate
          );
          this.$set(
            this.detailForm,
            "partyAuditResult2",
            res.data.secondPartyAuditResult
          );
          this.$set(
            this.detailForm,
            "partyAuditDate3",
            res.data.thirdPartyAuditDate
          );
          this.$set(this.detailForm, "mggAuditResult", res.data.mggAuditResult);
          this.$set(
            this.detailForm,
            "ggapAuditResult",
            res.data.ggapAuditResult
          );
          this.$set(this.detailForm, "gnn", res.data.gnn);
          this.crop = res.data.crop;
        });
    },
    getPartyAuditReportList(party, id) {
      rmcProdFarmApi.getPartyAuditReportList(party, id).then((res) => {
        console.log("获取列表", res);
        this.tableData = res.data;
      });
    },
    getFarmGroupList(sponsor) {
      rmcProdFarmApi.getFarmGroupList(sponsor).then((res) => {
        console.log("获取Farm Group", res);
        this.farmGroupOptions = res.data;
      });
    },
    getCrop() {
      rmcProdFarmApi
        .getCrop({
          "TT_RMC_PRODUCE_FARM:CROP": "TT_RMC_PRODUCE_FARM:CROP",
        })
        .then((res) => {
          console.log("rea", res);
          this.cropOptions = res["TT_RMC_PRODUCE_FARM:CROP"];
        });
    },
    partyChange(val) {
      if (val === 20) {
        this.isShow = true;
      } else {
        this.isShow = false;
      }
      this.getDetailInfo();
      this.getPartyAuditReportList(val, this.$route.query.rmcProduceFarmId);
    },
    uploadFile() {
      this.dialogVisible = true;
    },
    // 2方上传
    handleClose1() {
      this.dialogVisible1 = false;
      this.getPartyAuditReportList(
        this.detailForm.party,
        this.$route.query.rmcProduceFarmId
      );
    },
    // 3方上传
    handleClose2() {
      this.dialogVisible2 = false;
      this.getPartyAuditReportList(
        this.detailForm.party,
        this.$route.query.rmcProduceFarmId
      );
    },
    openFile1() {
      const isParty = !this.detailForm.party ? false : true;
      console.log("isParty", isParty);
      if (!isParty) {
        this.$message.error("请选择审核类型");
        return false;
      }
      this.seq = this.detailForm.party;
      this.bizId = this.$route.query.rmcProduceFarmId;
      this.recType = "RMC_PRODUCE_FARM_AUDIT_REPORT";
      this.dialogVisible1 = true;
    },
    openFile2() {
      const isParty = !this.detailForm.party ? false : true;
      console.log("isParty", isParty);
      if (!isParty) {
        this.$message.error("请选择审核类型");
        return false;
      }
      this.bizId = this.$route.query.rmcProduceFarmId;
      this.recType = "RMC_PRODUCE_FARM_AUDIT_REPORT";
      this.dialogVisible2 = true;
    },
    onDel(tmDocumentId, index, files) {
      fileService.deleteFile(tmDocumentId).then((res) => {
        if (res.code === "200") {
          this.getPartyAuditReportList(
            this.detailForm.party,
            this.$route.query.rmcProduceFarmId
          );
        }
      });
    },
    onDownload(row, index) {
      fileService.downloadFile(row).then((res) => {
        fileService.respToFile(res, row.documentName);
      });
    },
    onCancel() {
      this.fileList = [];
      this.uploadForm.fileName = "";
      this.uploadForm.reportType = "";
      this.dialogVisible = false;
    },
    onSubmit() {
      console.log("this.tableData", this.tableData);
      this.$refs["detailForm"].validate((valid) => {
        if (valid) {
          if (this.tableData.length === 0) {
            if (this.detailForm.party === 20) {
              this.$message.error(
                this.detailForm.farmName +
                "-农场清单验证审核报告:" +
                "附件类型2方审核报告未上传，请检查!"
              );
              return false;
            }
          }
          var obj = {};
          if (this.detailForm.party === 20) {
            var obj2 = {
              rmcProduceFarmIds: this.ids,
              partyAuditDate: this.detailForm.partyAuditDate2,
              partyAuditResult: this.detailForm.partyAuditResult2,
            };
            obj = Object.assign({}, obj2);
          }
          if (this.detailForm.party === 30) {
            var obj3 = {
              rmcProduceFarmIds: this.ids,
              partyAuditDate: this.detailForm.partyAuditDate3,
              mggAuditResult: this.detailForm.mggAuditResult,
              ggapAuditResult: this.detailForm.ggapAuditResult,
              gnn: this.detailForm.gnn,
              partyAuditResult: "",
            };
            obj = Object.assign({}, obj3);
          }
          var arr = [];
          this.tableData.forEach((ele) => {
            arr.push({
              tmDocumentId: ele.tmDocumentId,
              docComments: ele.docComments,
            });
          });
          rmcProdFarmApi
            .partyAuditUpdate(obj, this.detailForm.party)
            .then((res) => {
              console.log("提交", res);
              if (res.meta.code === 200) {
                if (this.detailForm.party === 20) {
                  this.$message.success("2方验证审核报告提交成功.");
                } else if (this.detailForm.party === 30) {
                  this.$message.success("3方验证审核报告提交成功.");
                }
                this.getDetailInfo();
                this.getPartyAuditReportList(
                  this.detailForm.party,
                  this.$route.query.rmcProduceFarmId
                );
                // this.$router.push('/rmcProdFarm')
              } else {
                this.$message.error(res.meta.msg);
              }
            });
        }
      });
    },
    routerBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style></style>
